import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import { Card } from "@/components/ui/card";
import { api } from "@/lib/api";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer, Tooltip, CartesianGrid } from "recharts";

const data = Array.from({ length: 12 }).map((_, i) => ({ m: ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"][i], approvals: 20 + Math.round(Math.random() * 40), rejections: 3 + Math.round(Math.random() * 12), disb: 15 + Math.round(Math.random() * 30) }));

export default function AdminReports() {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  return (
    <AdminLayout>
      <div className="space-y-6">
        <div>
          <div className="text-xs uppercase tracking-widest text-primary font-semibold">Reports</div>
          <h1 className="font-display text-3xl mt-2">Reports & Analytics</h1>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Card className="p-5"><div className="text-xs uppercase text-muted-foreground">Approval rate</div><div className="font-display text-2xl mt-2">{s.total_loans ? Math.round(((s.approved || 0) / s.total_loans) * 100) : 0}%</div></Card>
          <Card className="p-5"><div className="text-xs uppercase text-muted-foreground">Rejection rate</div><div className="font-display text-2xl mt-2">{s.total_loans ? Math.round(((s.rejected || 0) / s.total_loans) * 100) : 0}%</div></Card>
          <Card className="p-5"><div className="text-xs uppercase text-muted-foreground">Avg ticket size*</div><div className="font-display text-2xl mt-2">₹{s.approved ? Math.round((s.disbursed_total || 0) / (s.approved || 1)).toLocaleString("en-IN") : 0}</div></Card>
          <Card className="p-5"><div className="text-xs uppercase text-muted-foreground">Portfolio</div><div className="font-display text-2xl mt-2">₹{Number(s.disbursed_total || 0).toLocaleString("en-IN")}</div></Card>
        </div>
        <Card className="p-6">
          <div className="font-display text-xl mb-4">Trend (illustrative)</div>
          <div className="h-72">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={data}>
                <CartesianGrid stroke="hsl(var(--border))" strokeDasharray="3 3" />
                <XAxis dataKey="m" stroke="hsl(var(--muted-foreground))" fontSize={12} />
                <YAxis stroke="hsl(var(--muted-foreground))" fontSize={12} />
                <Tooltip />
                <Line type="monotone" dataKey="approvals" stroke="#4F46E5" strokeWidth={2} dot={false} />
                <Line type="monotone" dataKey="rejections" stroke="#F43F5E" strokeWidth={2} dot={false} />
                <Line type="monotone" dataKey="disb" stroke="#38BDF8" strokeWidth={2} dot={false} />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>
      </div>
    </AdminLayout>
  );
}
